import { defineAsyncComponent } from '../compat/vueCompat';
import { requestDialog } from './requestDialog';
import type { FolderDeleteDialogRequest } from '@mimir/web/dialogs/folderDeleteDialogRequest';

const DeleteFolderDialog = defineAsyncComponent(() => import('@mimir/web/components/Common/Dialogs/dialogs/DeleteFolderDialog.vue'));

export function showFolderDeleteDialog(req: FolderDeleteDialogRequest) {
  requestDialog(req, DeleteFolderDialog);
}
